<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            load: false,
            amount: 0,
            contract: {
                'contract_id': 0,
                'id': 0,
                'currency_id': 0,
            },
            bills: [],
            billsData: [],
        }
    },
    methods: {
        onChangeImpuesto(itemBase, tipo) {
            const factura = this.billsData[itemBase.bill_id];
            if (factura && factura.type == 1) {
                this.bills.forEach(item => {
                    if (item.bill_id === itemBase.bill_id) {
                        item[tipo] = itemBase[tipo];
                    }
                });
            }
        },
        addItem() {
            let item = {
                'id': '',
                'description': '',
                'bill_id': 0,
                'final_amount': 0,
                'discount': 0,
                'iva': 0,
                'ieps': 0,
                'isr_ret': 0,
                'iva_ret': 0,
                'total': 0
            };
            this.bills.push(item);
        },
        calcularTotales(item) {
            const montoBase = parseFloat(item.final_amount) || 0;
            const descuento = parseFloat(item.discount) || 0;

            const base = montoBase - descuento;

            const iva = item.iva ? base * 0.16 : 0;
            const ieps = item.ieps ? base * 0.08 : 0;
            const isrRet = item.isr_ret ? base * 0.10 : 0;
            const ivaRet = item.iva_ret ? base * 0.106666 : 0;

            // Calcular el total
            const total = base + iva + ieps - isrRet - ivaRet;


            return {
                iva,
                ieps,
                isrRet,
                ivaRet,
                total
            };
        },
        closedModal() {
            this.load = false;
            this.errors = {};
            this.send = false;
            this.amount = 0;
            this.contract = {};
            this.bills = [];
            this.billsData = [];
            this.$modal.hide('addCreateBillExternalRules');
        },
        addBillData(data = {
            name: 'Factura ' + this.billsData.length,
            billing_data_id: this.catalogue.companies_buildings[0].id,
            type: 1,
            currency_id: this.contract.currency_id,
            contract_dues_id: this.contract.id
        }) {
            this.billsData.push(data);
        },
        async triggerSave() {
            this.send = true;
            const data_form = new FormData();

            data_form.append('contract', JSON.stringify(this.contract));
            data_form.append('bills', JSON.stringify(this.bills));
            data_form.append('bills_data', JSON.stringify(this.billsData));

            let _endpoint = '/rules_billing';

            try {
                let { data } = await request.post(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-contracts');
                    this.send = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    const outerMessage = error.response.data.message;
                    const jsonString = outerMessage.split('Unable to create Invoice: ')[1];
                    const parsed = JSON.parse(jsonString);
                    let innerMessage = parsed.message;
                    alert(innerMessage);
                    this.errors = await this.errorNotification(error);
                }
                this.send = false;
            }
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        })
    },
    mounted() {
        this.catalogue.getCurrencies();

    },
    created() {
        Event.$on("event-show-addCreateBillExternalRuless", async (contract) => {
            console.log(contract);
            this.load = true;
            this.$modal.show('addCreateBillExternalRules');
            this.contract.contract_id = contract.id;
            this.contract.id = contract.id;
            this.contract.currency_id = contract.currency_id;

            // await this.catalogue.getBillingDataUser(contract.contract.user_id);
            await this.catalogue.get_companies_buildings(contract.building_id);

            let items = [];

            // Renta
            if (contract.unique_rent == 1 && contract.unique_rent_data) {
                items.push({
                    'id': contract.unique_rent_data.id,
                    'bill_id': 0,
                    'type': 1,
                    'description': 'Renta',
                    'final_amount': contract.unique_rent_data.subtotal,
                    'discount': 0,
                    'iva': 0,
                    'ieps': 0,
                    'isr_ret': 0,
                    'iva_ret': 0,
                    'total': 0
                });
            } else if (contract.departments) {
                console.log(contract.departments);
                contract.departments.forEach(department => {
                    items.push({
                        'id': department.id,
                        'bill_id': 0,
                        'type': 2,
                        'description': 'Renta / Piso ' + department.level + ' / ' + department.number,
                        'final_amount': department.subtotal_rent,
                        'discount': 0,
                        'iva': 0,
                        'ieps': 0,
                        'isr_ret': 0,
                        'iva_ret': 0,
                        'total': 0
                    });
                });
            }

            // Servicios
            if (contract.unique_services == 1) {
                contract.unique_services_data.forEach(service => {
                    if (service.include_rent == false && service.subtotal > 0) {
                        items.push({
                            'id': service.id,
                            'bill_id': 0,
                            'type': 3,
                            'description': service.service.name,
                            'final_amount': service.subtotal,
                            'discount': 0,
                            'iva': 0,
                            'ieps': 0,
                            'isr_ret': 0,
                            'iva_ret': 0,
                            'total': 0
                        });
                    }
                });
            } else if (contract.departments) {
                contract.departments.forEach(department => {
                    department.services.forEach(service => {
                        if (service.include_rent == false && service.subtotal > 0) {
                            items.push({
                                'id': service.id,
                                'bill_id': 0,
                                'type': 4,
                                'description': service.name + ' del piso ' + department.level + ' / ' + department.number,
                                'final_amount': service.subtotal,
                                'discount': 0,
                                'iva': 0,
                                'ieps': 0,
                                'isr_ret': 0,
                                'iva_ret': 0,
                                'total': 0
                            });
                        }
                    });
                });
            }

            if (contract.rules_billing.length > 0) {
                contract.rules_billing.forEach((rule, indexR) => {                  
                    this.addBillData({
                        name: rule.name,
                        billing_data_id: rule.billing_data_id,
                        type: parseInt(rule.type),
                        currency_id: contract.currency_id,
                        contract_dues_id: contract.id
                    });

                    if (rule.rules_items.length > 0) {
                        rule.rules_items.forEach(item => {
                            const idx = items.findIndex(it => it.id === item.item_id && it.type === parseInt(item.type));
                            items[idx].bill_id = indexR;
                            items[idx].discount = item.discount;
                            items[idx].iva = item.iva;
                            items[idx].ieps = item.ieps;
                            items[idx].isr_ret = item.isr_ret;
                            items[idx].iva_ret = item.iva_ret;
                        });
                    }
                });
            } else {
                this.addBillData({
                    name: 'Factura principal',
                    billing_data_id: this.catalogue.companies_buildings[0].id,
                    type: 1,
                    currency_id: contract.currency_id,
                    contract_dues_id: contract.id
                });
            }

            // let items = [];
            // contract.due_items.forEach(_item => {
            //     if (_item.item_bill == null) {
            //         items.push({
            //             'id': _item.id,
            //             'description': _item.description,
            //             'bill_id': 0,
            //             'final_amount': _item.final_amount,
            //             'discount': 0,
            //             'iva': 0,
            //             'ieps': 0,
            //             'isr_ret': 0,
            //             'iva_ret': 0,
            //             'total': 0
            //         });

            //     }                
            // });

            this.bills = items;
            this.load = false;
        });
    },
    watch: {

    }
}
</script>
<template>
    <modal name="addCreateBillExternalRules" :width="'80%'" :maxHeight="300" :height="'auto'"
        v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>

        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Reglas de facturación</h5>
        </div>
        <div class="modal-body">
            <div class="row" v-if="load">
                <div class="col-md-12 text-center">
                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                    <h5>Cargando</h5>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-4 mt-3">
                    <div class="card" v-for="(bill, index) in billsData" :key="index">
                        <div class="card-body p-0">
                            <div class="row">
                                <div class="col-md-12">
                                    <label>Nombre</label>
                                    <input type="text" class="form-control" v-model="bill.name">
                                    <div v-if="errors && errors.contract" class="text-danger">{{ errors.contract[0] }}
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label>Datos de facturación</label>
                                    <select class="form-control" v-model="bill.billing_data_id">
                                        <option :value="bill.id" v-for="(bill, index) in catalogue.companies_buildings"
                                            :key="index">
                                            {{ bill.name }} - {{ bill.rfc }}
                                        </option>
                                    </select>
                                    <div v-if="errors && errors.bills" class="text-danger">{{ errors.bills[0] }}</div>
                                </div>
                                <div class="col-md-12">
                                    <label>Tipo de facturación</label>
                                    <select class="form-control" v-model="bill.type">
                                        <option value="1">Integrado</option>
                                        <option value="2">Desglosado</option>
                                    </select>
                                    <div v-if="errors && errors.type" class="text-danger">{{ errors.type[0] }}</div>
                                </div>
                                <div class="col-md-12" v-if="contract.currency_id != 1">
                                    <label>Moneda</label>
                                    <select class="form-control" v-model="bill.currency_id">
                                        <option :value="currency.id" v-for="(currency, index) in catalogue.currencies"
                                            :key="index">
                                            {{ currency.name }}
                                        </option>
                                    </select>
                                    <div v-if="errors && errors.currency_id" class="text-danger">
                                        {{ errors.currency_id[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt-3 text-center">
                        <button type="button" @click="addBillData()" class="btn btn-outline-success">
                            <i class="fas fa-save"></i> Agregar Factura
                        </button>
                    </div>
                </div>
                <div class="col-md-8 mt-3">
                    <div class="row" v-for="(item, index) in bills" :key="index">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-body p-0">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label>Item</label>
                                            <br>
                                            <span v-if="item.id">{{ item.description }}</span>
                                            <input type="text" v-model="item.description" class="form-control" v-else>
                                            <hr>
                                        </div>
                                        <div class="col-md-4">
                                            <label>Facturar</label>
                                            <select class="form-control" v-model="item.bill_id">
                                                <option :value="index" v-for="(bill, index) in billsData" :key="index">
                                                    {{ bill.name }}
                                                </option>
                                            </select>
                                            <div v-if="errors && errors.bills" class="text-danger">{{ errors.bills[0] }}
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <label>Monto</label><br>
                                            <span v-if="item.id">{{ item.final_amount | toCurrency }}</span>
                                            <money v-else class="form-control from-control-sm"
                                                v-model="item.final_amount"></money>
                                        </div>
                                        <div class="col-md-4">
                                            <label>Descuento</label>
                                            <money class="form-control from-control-sm" v-model="item.discount">
                                            </money>
                                        </div>
                                        <div class="col-md-3 text-center">
                                            <label>IVA</label>
                                            <input type="checkbox" class="form-control from-control-sm"
                                                v-model="item.iva" @change="onChangeImpuesto(item, 'iva')">
                                        </div>
                                        <div class="col-md-3 text-center">
                                            <label>IEPS</label>
                                            <input type="checkbox" class="form-control from-control-sm"
                                                v-model="item.ieps" @change="onChangeImpuesto(item, 'ieps')">
                                        </div>
                                        <div class="col-md-3 text-center">
                                            <label>ISR RET</label>
                                            <input type="checkbox" class="form-control from-control-sm"
                                                v-model="item.isr_ret" @change="onChangeImpuesto(item, 'isr_ret')">
                                        </div>
                                        <div class="col-md-3 text-center">
                                            <label>IVA RET</label>
                                            <input type="checkbox" class="form-control from-control-sm"
                                                v-model="item.iva_ret" @change="onChangeImpuesto(item, 'iva_ret')">
                                        </div>
                                        <div class="col-md-12">
                                            <hr>
                                        </div>
                                        <!-- Subtotal -->
                                        <div class="col-6">
                                            <label>Subtotal</label>
                                        </div>
                                        <div class="col-6 text-right">
                                            {{ item.final_amount | toCurrency }}
                                        </div>

                                        <!-- Descuento -->
                                        <div class="col-6" v-if="item.discount > 0">
                                            <label>Descuento</label>
                                        </div>
                                        <div class="col-6 text-right" v-if="item.discount > 0">
                                            {{ item.discount | toCurrency }}
                                        </div>

                                        <!-- IVA -->
                                        <div class="col-6" v-if="item.iva">
                                            <label>IVA (16%)</label>
                                        </div>
                                        <div class="col-6 text-right" v-if="item.iva">
                                            {{ calcularTotales(item).iva | toCurrency }}
                                        </div>

                                        <!-- IEPS -->
                                        <div class="col-6" v-if="item.ieps">
                                            <label>IEPS (8%)</label>
                                        </div>
                                        <div class="col-6 text-right" v-if="item.ieps">
                                            {{ calcularTotales(item).ieps | toCurrency }}
                                        </div>

                                        <!-- ISR Retenido -->
                                        <div class="col-6" v-if="item.isr_ret">
                                            <label>ISR Ret. (10%)</label>
                                        </div>
                                        <div class="col-6 text-right" v-if="item.isr_ret">
                                            - {{ calcularTotales(item).isrRet | toCurrency }}
                                        </div>

                                        <!-- IVA Retenido -->
                                        <div class="col-6" v-if="item.iva_ret">
                                            <label>IVA Ret. (10.666%)</label>
                                        </div>
                                        <div class="col-6 text-right" v-if="item.iva_ret">
                                            - {{ calcularTotales(item).ivaRet | toCurrency }}
                                        </div>

                                        <div class="col-12">
                                            <hr>
                                        </div>

                                        <!-- Total -->
                                        <div class="col-6">
                                            <label>Total</label>
                                        </div>
                                        <div class="col-6 text-right">
                                            {{ calcularTotales(item).total | toCurrency }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">

                    <button :disabled="send" type="button" @click="triggerSave()"
                        class="btn float-right btn-outline-success">
                        <span v-if="send">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                        </span>
                        <span v-else>
                            <i class="fas fa-save"></i> Guardar
                        </span>
                    </button>
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>

            </div>
        </div>
    </modal>
</template>